class Controller {
  constructor($state, $location, $window, $stateParams, $injector, Lists) {
    "ngInject";
    this.Captain = $injector.get("Captain");
    this.$state = $state;
    this.Events = $injector.get("Events");
    this.$location = $location;
    this.$stateParams = $stateParams;
    this.ResetFields = $injector.get("ResetFields");
    this.CaptainsTransforms = $injector.get("CaptainsTransforms");

    this.sections = $injector.get("Sections").fleetSections;
    this.fields = this.CaptainsTransforms.fields;
    this.filters = this.CaptainsTransforms.filters;
    this.page = this.$stateParams.page;
    this.limit = this.$stateParams.limit;
    this.activeParams = this.$stateParams;
    this.lists = Lists;

    this.addOptions = this.CaptainsTransforms.addOptions;
    this.item = this.CaptainsTransforms.item;
    this.newItemModel = {};
    this.addItemEvent = this.Events.getAddEvent("captains");
    this.paginateEvent = this.Events.getPaginateEvent("captains");
    this.filterEvent = this.Events.getFilterEvent("captains");
    this.sortEvent = this.Events.getSortEvent("captains");
  }
}

export default Controller;



// WEBPACK FOOTER //
// ./src/pages/captains/captains.controller.js